import { createSlice } from "@reduxjs/toolkit";

const accountRestrictionSlice = createSlice({
  name: "accountRestriction",
  initialState: {
    isRestricted: false,
    restrictionReason: "",
  },
  reducers: {
    setAccountRestriction: (state, action) => {
      const { isRestricted, restrictionReason } = action.payload;
      state.isRestricted = Boolean(isRestricted);
      state.restrictionReason = restrictionReason || "";
    },
    clearAccountRestriction: (state) => {
      state.isRestricted = false;
      state.restrictionReason = "";
    },
  },
});

export const { setAccountRestriction, clearAccountRestriction } =
  accountRestrictionSlice.actions;

export default accountRestrictionSlice.reducer;
